export default "__VITE_ASSET__406213e8__"